const locale = {
    placeholder: 'Zaman Seç',
};
export default locale;



// WEBPACK FOOTER //
// ./components/time-picker/locale/tr_TR.tsx